import { FileField, FileInput, SimpleForm, Toolbar, SaveButton, useNotify, Create } from "react-admin"
import {useDropzone} from 'react-dropzone'
import React, { useEffect, useState} from 'react'
import { useAuth0 } from "@auth0/auth0-react";
import { CloudUpload } from "@material-ui/icons";
import { Box, LinearProgress, Typography } from "@material-ui/core";

function LinearProgressWithLabel(props) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" >{`${Math.round(
            props.value,
          )}%`}</Typography>
        </Box>
      </Box>
    );
}


export const UploadFile = (data)=>{

   
    let [token, setToken] = useState('');
    let [progress, setState] = useState(0);
    //let [serverProgress, setServerState] = useState(0);
    let [files, setFileState] = useState([]);

    // const eventSource = getEventSource(REACT_APP_SERVER_URL + '/api/abricate/tools/live');

    // eventSource.onmessage = event => {
    //     console.log("Mensaje: ", event);
    //     const response = JSON.parse(event.data);
    //     setServerState(Math.round(response.porcentage));
    // }
    // eventSource.onerror = error => {
    //     console.log("Error");
    // }
    const { getAccessTokenSilently } = useAuth0();
    const UploadButton = props => (
        <Toolbar {...props}>
            <SaveButton disabled={files.length<=0} label="Upload" icon={<CloudUpload/>} />
        </Toolbar>
    );
    useEffect(() => {
        async function getToken() {
            const getToken = await getAccessTokenSilently();
            setToken(getToken);
        }
        getToken();
     }, [getAccessTokenSilently])

    const notify = useNotify();

    const onChange = (files)=>{
        setFileState(files);
    }

    const onDrop = acceptedFiles => {
        const formData = new FormData();
        const filesToUpload = [];
        for(let file of acceptedFiles.files) {
            filesToUpload.push(file.rawFile);
            formData.append("files", file.rawFile);
        }
        const { REACT_APP_SERVER_URL } = process.env;
        var xhr = new XMLHttpRequest();
        xhr.upload.onprogress = (event)=>{
            if (event.lengthComputable) {
                var percentComplete = event.loaded / event.total;  
                progress = percentComplete*100;
                if(progress===100){

                }
                setState(progress);
            }
        }        
        xhr.onreadystatechange = (data,notifier=notify) => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    notifier(`Archivo cargado correctamente`, { type: 'success'},5);
                } else {
                    notifier(`Error al cargar el archivo`, { type: 'error' },5);
                }
                setState(0);
            }
        }
        xhr.open("POST", REACT_APP_SERVER_URL + '/api/files/multiple');
        xhr.setRequestHeader('Authorization',`Bearer ${token}`)
        xhr.send(formData);
    }
    useDropzone({onDrop})
    const {staticContext, ...rest} = data;
    return (
        <Box>
            <Create {...rest} basePath="nose" resource="abricate">
                <SimpleForm save={onDrop} toolbar={<UploadButton/>}>
                    <FileInput onSubmit={onDrop} onChange={onChange} source="files" label="Related files" accept="text/csv" multiple>
                        <FileField source="src" title="title" />
                    </FileInput>
                </SimpleForm>
            </Create>
            <LinearProgressWithLabel value={progress}/>
            {/* {
                progress == 100 &&
                <div style={{display:'flex'}}>
                    <p style={{alignSelf:'center',marginBottom:0, marginRight:'1em'}}>
                        Procesando archivos {serverProgress} %
                    </p> 
                    <CircularProgress></CircularProgress>
                </div>
            } */}
        </Box>
       
    );
}
